<template>
  <section
    class="relative z-2 -mt-8 overflow-hidden rounded-t-[40px] bg-white py-20 md:py-28 lg:mt-0 lg:rounded-t-none"
  >
    <!--    <DefaultGrid class="gap-y-12 md:gap-y-16">-->
    <DefaultGrid>
      <div class="col-span-full mb-12 text-center md:mb-16">
        <h2
          class="type-font-salt-ss02 text-[56px] leading-[0.9] font-medium tracking-[-0.03em] md:text-[80px]"
        >
          Why
          <HomeHighlight src="/images/blue-text-highlight.svg" :rotate="-0.81"
            >wait?</HomeHighlight
          >
        </h2>
      </div>

      <div class="relative col-span-full mb-0 lg:mb-0 xl:mb-24">
        <HomeScrollTextReveal
          class="type-heading-4 mx-auto space-y-6 text-center xl:max-w-xl"
          :paragraphs="paragraphs"
        />

        <div
          class="relative -mx-8 mt-8 aspect-[6/5] md:mx-auto md:mt-0 md:aspect-auto md:h-[420px] md:w-full xl:static xl:aspect-auto xl:h-auto xl:max-w-none"
        >
          <HomeStatCard
            class="bg-yellow-light absolute top-[22%] left-[-0.5%] z-10 aspect-square w-[54%] rotate-[5deg] p-6 transition-transform duration-300 hover:z-30 hover:translate-x-3 hover:scale-110 hover:-rotate-3 md:top-[113px] md:left-[-74px] md:z-20 md:w-[315px] lg:left-[-62px] xl:top-[-35px] xl:left-[-79px] xl:h-[315px] xl:w-[315px] xl:rotate-6"
            label="Notifications received per day"
            stat="237+"
          />
          <HomeStatCard
            class="bg-pink absolute top-0 right-[-2%] z-20 aspect-square w-[54%] rotate-[-5deg] p-6 transition-transform duration-300 hover:z-30 hover:scale-110 hover:-rotate-9 md:right-[-157px] md:z-10 md:w-[315px] lg:right-[-145px] xl:top-auto xl:bottom-[-151px] xl:h-[315px] xl:w-[315px] xl:rotate-[-6deg]"
            label="Time spent per day on smartphones"
            stat="5.5+ hours"
          />
        </div>
      </div>

      <div class="col-span-full sm:-mt-11.25 lg:-mt-12.5 xl:mt-0">
        <MuxVideoPlayer
          class="aspect-video rounded-3xl"
          playback-id="LCtdyKIp60001qZ9g00kLWFccsok00gqUUqSmSEMCmslVCg"
          :gif-start="66"
        />
      </div>
    </DefaultGrid>
  </section>
</template>

<script setup lang="ts">
const paragraphs = [
  'Wait Mate is a movement of parents who believe childhood should be shaped by real people, real-world experiences and connection before smartphones.',
  'By connecting parents and building safe, supportive communities, Wait Mate helps parents wait as long as possible before giving their child a smartphone.',
  "Waiting isn't saying no. It's saying not yet. Waiting gives developing brains more time before smartphones become part of everyday life.",
]
</script>
